import { BookOpen, Headphones, Film } from "lucide-react";

const SecondData = [
  {
    id: 1,
    icon: BookOpen,
    title: "Read & Discover",
    description: "Explore a wide range of ebooks filled with imagination, culture, and wisdom."
  },
  {
    id: 2,
    icon: Headphones,
    title: "Listen & Feel",
    description: "Enjoy soulful audio stories in Hindi, English, and Garhwali — perfect for all moods."
  },
  {
    id: 3,
    icon: Film,
    title: "Watch & Learn",
    description: "Engage with rich video content from fun kids’ stories to thought-provoking documentaries."
  }
];

export default SecondData;
